<template>
  <v-container>
    <material-wizard
      title="Remover Georreferenciado"
      subtitle="Selecione as datas e as entidades que serão removidas"
      v-model="tab"
      :available-steps="tabsLiberadas"
      :wizzardMixinsOn="true"
      :tabs="tabs"
      class="mx-auto"
      @click:next="nextStep()"
      @click:prev="prevStep()"
      :loading="loading"
    >
      <remover-georreferenciado-wizard-tabs
        ref="expurgoBdgdParametros"
        @step-observer="updateTabStatus($event)"
      />
    </material-wizard>
  </v-container>
</template>

<script>
import GeorreferenciadoService from "@/services/RemoverGeorreferenciadoService"
import wizardMixins from '@/mixins/wizardMixins.js';
import tourMixins from '@/mixins/tourMixins';

export default {
  mixins: [wizardMixins, tourMixins],

  components: {
    RemoverGeorreferenciadoWizardTabs: () => import('@/components/removedorGeorreferenciado/RemoverGeorreferenciadoWizardTabs'),
    MaterialWizard: () => import('@/components/base/MaterialWizard'),
  },

  mounted(){
    this.iniciarTourPrimeiraTab();
  },

  data: () => ({
    tabs: [
      "Datas",
      "Entidades",
      "Confirmação"
    ],
    loading: false,
    dados: {},
    arrPrimeiraTabTour: [
      {
        element: '#expurgo-datas-versoes',
        intro: 'Aqui você poderá escolher qual data e versão sera apagada.',
        scrollTo: "tooltip",
        position: 'right'
      }, 
    ],
    arrSegundaTabTour: [
      {
        element: "#expurgo-registro-entidades",
        intro: "Aqui você poderá escolher quais entidades serão apagadas.",
        scrollTo: "tooltip",
        position: "right"
      },
    ],
    arrTerceiraTabTour: [
      {
        element: "#total-registros-expurgo",
        intro: "Aqui você poderá visualizar a quantidade de registros que seram eliminados.",
        scrollTo: "tooltip",
        position: "top"
      },
      {
        element: '#wizard-next',
        intro: 'Após a Confirmação das informações, clique aqui para salvar e executar o Expurgo dos registros Georreferenciados.',
        scrollTo: "tooltip",
        position: 'left'
      },
    ],

  }),

  methods:{
    save(){
      let data = this.$refs.expurgoBdgdParametros.exportData();
      this.loading = true;
      
      GeorreferenciadoService.salvar(data).then(() => {
        this.$toast.success('Expurgo Georreferenciado salvo com sucesso.', '',{position:'topRight'})
        this.$router.replace({ name: 'Removedor de registro georreferenciado' });
      })
      .catch(() => {
        this.$toast.error('Erro ao salvar Expurgo de BDGD.', '',{position:'topRight'});
      })
      .finally(() => this.loading = false);
    },

    iniciarTourPrimeiraTab() {
      this.doneLabel = 'Proximo';
      this.desativarTourAoSair = false;

      let onBeforeExitFunction = {
        func: (() => {
          this.tab = 1;
          this.iniciarTourSegundaTab();
        })
      };
      
      this.iniciarTour(this.arrPrimeiraTabTour, [], [], [onBeforeExitFunction]);
    },

    iniciarTourSegundaTab() {
      this.doneLabel = 'Proximo';
      this.desativarTourAoSair = false;

      let onBeforeExitFunction = {
        func: (() => {
          this.tab = 2
          this.iniciarTourTerceiraTab();
        })
      };

      this.iniciarTour(this.arrSegundaTabTour, [], [], [onBeforeExitFunction]);
    },

    iniciarTourTerceiraTab() {
      this.doneLabel = 'Finalizar';
        this.desativarTourAoSair = true;

      let onBeforeExitFunction = {
        func: (() => this.tab = 0)
      };

      this.iniciarTour(this.arrTerceiraTabTour, [], [], [onBeforeExitFunction]);
    },
  },

}
</script>